import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (accessToken) {
      navigate("/dashboard");
    }
    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      {/* Hero Section */}
      <section className="hero-modern">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Streamline Your Business with
                <span className="gradient-text"> Optimus</span>
              </h1>
              <p className="hero-subtitle">
                Powerful ETIMS APIs, modern POS system, and comprehensive
                business APIs to accelerate your digital transformation
              </p>
              <div className="hero-actions">
                <Link to="/login" className="btn-primary">
                  Get Started
                </Link>
              </div>
            </div>
            <div className="hero-visual">
              <div className="dashboard-preview">
                <img
                  src="/assets/59.jpg"
                  alt="Data Center Infrastructure"
                  className="hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Optimus?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Real-time Analytics</h3>
              <p>
                Get instant insights into your business performance with
                comprehensive dashboards and reports
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure & Compliant</h3>
              <p>
                ETIMS compliant with enterprise-grade security to protect your
                business data
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Lightning Fast</h3>
              <p>
                Optimized for speed and performance to keep your business
                running smoothly
              </p>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Home;
